import { useContext } from 'react';

import {
  Col,
  Container,
  Row,
} from 'react-bootstrap';

import {
  BrandingContext,
  GeoContext,
  InsuranceDataContext,
  LayoutContext,
  NotificationsContext,
  SessionContext,
} from '../libs/contexts.js';
import {
  BaseMobileFaq,
  BaseMobileFooter,
  BaseMobileHeader,
  BaseMobileMenu,
  BaseMobileProgressBar,
  BaseMobileSidebar,
} from './base-mobile.jsx';

export const CorpoMobileLayout = ({ MyOutlet }) => {

    const { layout } = useContext(LayoutContext);


    return (

        <>
            <div className="content-container">
                <CorpoMobileMenu />
                <Container fluid>
                    <Row>
                        <Col className="desktop-area px-0">
                            <Container fluid>
                                <Row>
                                    <Col className='px-0'>
                                        <Container fluid>
                                            <Row>
                                                <Col>
                                                    <CorpoMobileHeader />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    { "yes" === layout.faq ?
                                                        <CorpoMobileFaq />
                                                        :
                                                        <>
                                                            { "jump" === layout.specialView ?
                                                                <p>We are getting your quote ready, please hold...</p>
                                                                :
                                                                <MyOutlet></MyOutlet>
                                                            }</>

                                                    }

                                                </Col>
                                            </Row>
                                        </Container>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </Container>
            </div>

            { "end" !== layout.currentScreen &&
                <CorpoMobileFooter />
            }


        </>
    )


}

export const CorpoMobileFooter = () => {

    return (
        <>
            <BaseMobileFooter />
        </>
    );
}

export const CorpoMobileHeader = () => {

    return (
        <>
            <BaseMobileHeader />
        </>
    )

}

export const CorpoMobileMenu = () => {
    return (
        <BaseMobileMenu />
    )
}

export const CorpoMobileProgressBar = () => {

    return (
        <BaseMobileProgressBar />
    )

}

export const CorpoMobileSidebar = () => {

    return (
        <BaseMobileSidebar />
    )

}

